import axios from 'axios';
//import config from '../../config';
import {envConfig as config} from '../../environment';
export const getSourcePersonAllApi = async()=>{
   // console.log("sourcePersons çalıştı");
   const url = `${config.apiUrl}/v1/sourcePersons/`;
   return await axios.get(url)
   .then(response => response.data)
   


}

export const getSourcePersonBySourcePersonIdApi = (sourcePersonId)=>{
    const url = `${config.apiUrl}/v1/sourcePersons/${sourcePersonId}`;
    return axios.get(url)
    .then(response => response.data);
 }
